module.exports = __webpack_public_path__ + "static/media/splash-en.0985596a.jpg";